export default "__VITE_ASSET__CYlqn8SP__"